<template>
    <div>
      <!-- <pre>{{meta}}</pre> -->
        <ag-grid-vue
            ref="agGridTable"
            :components="components"
            :gridOptions="gridOptions"
            class="ag-theme-material w-100 ag-grid-table"
            :columnDefs="columnDefs"
            :defaultColDef="defaultColDef"
            :style="{minHeight: (meta.limit * 48 + 75) + 'px'}"
            :rowData="limitedTableList"
            rowSelection="multiple"
            colResizeDefault="shift"
            :animateRows="true"
            :floatingFilter="false"
            :pagination="true"
            :paginationPageSize="paginationPageSize"
            :suppressPaginationPanel="true"
            :enableRtl="$vs.rtl"
            @cell-value-changed="onCellValueChanged"
            @row-selected="CellvalueSelectDeselect"
            @cell-clicked="cellSingleClickedProject"
            @grid-ready="onGridReady"
            @sortChanged="sortFun"
            >
        </ag-grid-vue>
        <vs-row  class="mt-2" vs-type="flex" vs-justify="space-between">
           <vs-col vs-w="4" vs-type="flex" vs-justify="start" vs-align="center">
          <ItemsPerTableDropdown
            tableName="project_table"
            @change="(pageLimit) => pageLimitSet = pageLimit"
          />
        </vs-col>
      <vs-col vs-xs="12" vs-sm="6" vs-lg="8">
        <pagination
          style="float: right"
          :meta="meta"
          @page-change="ProjecthandlePageChange"
        />
      </vs-col>
    </vs-row>
    </div>
</template>

<script>
import deadlineFormat from './components/deadline.vue'
import { PermissionMiddleware } from '@/mixins/middleware/PermissionMiddleware'
import { Project } from './mixins/project.js'
import Pagination from '@/components/common/pagination'
import { projectUpdate } from '@/api/task-project.js'
import router from '@/router'
import { AgGridVue } from 'ag-grid-vue'
import { mapGetters, mapActions } from 'vuex'
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import CellRendererActionsProject from './components/CellRendererActionsProject.vue'
export default {
  name: 'Project-Listing',
  components: {
    AgGridVue,
    CellRendererActionsProject,
    router,
    Pagination,
    deadlineFormat
  },
  mixins: [Project, PermissionMiddleware],
  props: ['filterDataList'],
  data () {
    return {
      gridOptions: {
        accentedSort: true
      },
      sorting_obj: {
        field_type: '',
        attribute: '',
        direction: ''
      },
      isRowSelected: false,
      gridApi: null,
      defaultColDef: {
        sortable: true,
        editable: true,
        resizable: true,
        suppressMenu: true,
        autoHeight: true
      },
      components: {
        CellRendererActionsProject
      },
      columnDefs: [
        {
          headerName: '#',
          field: 'row_index',
          sortable: false,
          filter: true,
          width: 60,
          resizable: true,
          editable: false,
          valueGetter: params => {
            return (
              this.meta.limit *
                (this.meta.current_page - 1) +
              params.node.rowIndex +
              1
            )
          }
        },
        {
          headerName: 'Name',
          field: 'name',
          width: 200,
          filter: true,
          editable: false,
          cellStyle: { color: 'blue', cursor: 'pointer' }
        },
        {
          headerName: 'Details',
          field: 'details',
          filter: true,
          editable: true,
          width: 250
        },
        {
          headerName: 'No. of Task',
          field: 'no_of_tasks',
          filter: true,
          editable: false,
          width: 100
        },
        {
          headerName: 'Deadline',
          field: 'due_date',
          width: 140,
          editable: false,
          filter: true,
          cellRendererFramework: 'deadlineFormat'
        },
        {
          headerName: 'Action',
          field: 'action',
          filter: false,
          editable: false,
          sortable:false,
          width: 70,
          cellRendererFramework: 'CellRendererActionsProject'
        }
      ]
    }
  },
  computed: {
    ...mapGetters(['get_task_deleted_id']),
    limitedTableList () {
      return this.ListOfProjectData
    }
  },
  watch: {
    get_task_deleted_id () {
      if (this.get_task_deleted_id) {
        const table = this.ListOfProjectData
        const dlt_id = table.findIndex(
          (item) => item.id === this.get_task_deleted_id
        )
        table.splice(dlt_id, 1)
        table.map((row, index) => {
          row.row_index = index + 1
        })
        this.ListOfProjectData = table
        if (this.ListOfProjectData.length === 0 && !this.meta.next_page_url) {
          this.ProjecthandlePageChange(this.meta.current_page - 1)
        } else {
          this.ProjecthandlePageChange(this.meta.current_page)
        }
      }
    },
    pageLimitSet () {
      this.ProjecthandlePageChange(1)
    },
    filterDataList () {
      this.ListOfProjectData = this.filterDataList
    }

  },
  mounted () {
    this.gridApi = this.gridOptions.api
    if (this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector('.ag-header-container')
      header.style.left = `-${  String(Number(header.style.transform.slice(11, -3)) + 9)  }px`
    }
  },
  methods: {
    ...mapActions(['SET_DEFAULT_ID']),
    async sortFun () {
      try {
        const sortState = this.gridOptions.api.getSortModel()
        if (sortState.length == 0) {
          console.log('No sort active')
        } else {
          this.sorting_obj.field_type = 'system'
          this.sorting_obj.attribute = sortState[0].colId
          this.sorting_obj.direction = sortState[0].sort
          console.log(this.sorting_obj)
          this.ProjecthandlePageChange(this.meta.current_page)
        }
      } catch (e) {}
    },
    onGridReady () {
      this.gridOptions.api.sizeColumnsToFit()
    },
    cellSingleClickedProject (params) {
      if (params.column.colId === 'name') {
        this.$router
          .push({
            name: 'project-details',
            params: { id: params.data.id }
          })
          .catch(() => {})
      }

    },

    CellvalueSelectDeselect () {
      this.gridApi = this.gridOptions.api
      const selectedNodes = this.gridApi.getSelectedNodes()
      //
      if (selectedNodes) {
        const selecttedNode = this.gridApi.getSelectedNodes()
        const selectedRows = selecttedNode.map((node) => node.data)
        if (selectedRows.length > 1) {
          this.isRowSelected = true
        } else {
          this.isRowSelected = false
        }
      } else {
        this.isRowSelected = false
      }
    },
    getSelectedRows () {
      const selectedNodes = this.gridApi.getSelectedNodes()
      const selectedData = selectedNodes.map((node) => node.data)
      return selectedData
    },
    onCellValueChanged (params) {
      const data = []
      data.colId = params.column.getId()
      data.proj_id = params.data.id
      if (data.colId === 'name') {
        data.fieldvalue = params.data.name
        data.colId = 'name'
        if (data.fieldvalue === '') {
          this.$vs.notify({
            title: 'Warning',
            text: 'Name field must be greater than 0',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning',
            time: 8000
          })
          return false
        }
      } else if (data.colId === 'details') {
        data.fieldvalue = params.data.details
        data.colId = 'details'
        // if (data.fieldvalue === '') {
        //   this.$vs.notify({
        //     title: 'Warning',
        //     text: 'Details field must be greater than 0',
        //     iconPack: 'feather',
        //     icon: 'icon-alert-circle',
        //     color: 'warning',
        //     time: 8000
        //   })
        //   return false
        // }
      }
      this.update_user(data)
    },
    async update_user (data) {
      const project_id = data.proj_id
      const payload = {
        updateField: {
          [data.colId]: data.fieldvalue
        }
      }
      try {

        const { data } = await projectUpdate(localStorage.getItem('customer_id'), project_id, payload)

        this.$vs.notify({
          title: 'Success',
          text: 'Project Updated Successfully',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success'
        })
      } catch (api_error) {


        this.$vs.notify({
          title: 'Warning',
          text: api_error.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning',
          time: 3000
        })
      }
    },
    ProjecthandlePageChange (page) {
      setTimeout(() => {
        const queryPayloadString = Object.assign({}, this.$route.query)
        queryPayloadString.page = page
        queryPayloadString.limit = this.pageLimitSet
        const pageScroll = document.documentElement.scrollTop
        this.$router
          .replace({ path: '/pages/tasks-project', query: queryPayloadString })
          .catch(() => {}).then(() => {
            document.documentElement.scrollTop = pageScroll
          })
        let queryPayload = Object.assign({}, this.$route.query)
        queryPayload.current_page = page
        queryPayload.limit = this.pageLimitSet
        queryPayload.table_name = 'project_table'
        queryPayload = {...queryPayload, ...this.sorting_obj}
        this.fetchProject(queryPayload)
      }, 0)
    }
  }


}
</script>
